import React from "react";
import logo from "../assets/images/logo.png";

const Logo = () => {
  return <img src={logo} alt="jobster" className="logo" />;
};

export default Logo;
